
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gp1v_1w0bf_5",
  "action-button": "awsui_action-button_1gp1v_1w0bf_9",
  "control": "awsui_control_1gp1v_1w0bf_13",
  "inline-label": "awsui_inline-label_1gp1v_1w0bf_17"
};
  